import { createFileRoute } from '@tanstack/react-router'
import FeedbackPage from 'pages/app/feedback-page/FeedbackPage'

export const Route = createFileRoute('/_authenticated/app/feedback')({
  component: FeedbackPage,
})
